import { api } from '@/axios';
import request from "@/assets/utils/request"

/**
 * @description:
 * @author:
 */
//获取所有得机器数据
export function machineList() {
    return request({
      url: '/machine/find/allFields',
      method: 'get'
    })
  }

//修改机器的isChoose状态
export function isChooseUpdate(data){
  return request({
    url:"/machine/update/choose",
    method:"post",
    data:data
  })
}

//查询是否卷绕机
export function MTypeQuery() {
  return request({
    url: '/machine/find/category',
    method: 'get'
  })
}

//修改是否卷绕机状态
export function MTypeUpdate(data){
  return request({
    url:"/machine/update/category",
    method:"post",
    data:data
  })
}

//查询设备状态
export function DeviceStates() {
  return request({
    url: '/machine/find/states',
    method: 'get'
  })
}

//查询用户登入
export function userQuery(data){
  return request({
    url:"/login",
    method:"post",
    data:data
  })
}

//修改图类型
export function chartUpdate(data){
  return request({
  url: '/machine/chartNumber',
  method: 'post',
  data:data
  })
}


